import {
  Card,
  Table,
  Typography,
  Tag,
  Space,
  Avatar,
  message,
  Button,
  Modal,
  Form,
  InputNumber,
  Input,
} from "antd";
import React, { useEffect, useState } from "react";
import { get, post } from "../../utils/http";

const { Title } = Typography;

function UserList() {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  
  const [adjustModalVisible, setAdjustModalVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [form] = Form.useForm();

  const fetchUsers = async (page = 1) => {
    setLoading(true);
    try {
      const res = await get("/api/manage/user-list", { page, offset: 20 });
      if (res.data.code === 0) {
        setDataSource(res.data.data.list || []);
        setTotal(res.data.data.total || 0);
        setCurrentPage(page);
      }
    } catch (err) {
      console.error("获取用户列表失败:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  const handleAdjustPoints = (record: any) => {
    setCurrentUser(record);
    form.setFieldsValue({ points_change: 10, description: '管理员手动调整' });
    setAdjustModalVisible(true);
  };

  const handleAdjustSubmit = async () => {
    try {
      const values = await form.validateFields();
      const res = await post('/api/manage/adjust-points', {
        user_id: currentUser.id,
        points_change: values.points_change,
        description: values.description
      });
      
      if (res.data.code === 0) {
        message.success('调整成功');
        setAdjustModalVisible(false);
        fetchUsers(currentPage);
      } else {
        message.error(res.data.errorMsg || '调整失败');
      }
    } catch (err) {
      console.error('调整积分失败:', err);
    }
  };

  const columns = [
    {
      title: "头像",
      dataIndex: "avatar",
      key: "avatar",
      width: 80,
      render: (avatar: string) => (
        <Avatar src={avatar || '/static/logo.png'} />
      ),
    },
    {
      title: "用户名",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "姓名",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "手机号",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "积分余额",
      dataIndex: "points",
      key: "points",
      render: (points: number) => (
        <Tag color="gold" style={{ fontWeight: 'bold' }}>
          {points || 0}
        </Tag>
      ),
    },
    {
      title: "注册时间",
      dataIndex: "created_at",
      key: "created_at",
      width: 180,
    },
    {
      title: "状态",
      dataIndex: "is_deleted",
      key: "is_deleted",
      render: (is_deleted: boolean) => (
        <Tag color={is_deleted ? "error" : "success"}>
          {is_deleted ? "已注销" : "正常"}
        </Tag>
      ),
    },
    {
      title: "操作",
      key: "action",
      width: 150,
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" onClick={() => handleAdjustPoints(record)}>调整积分</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24, background: "#f5f5f5", minHeight: "100vh" }}>
      <Card
        title={
          <Title level={3} style={{ margin: 0 }}>
            用户管理
          </Title>
        }
      >
        <Table
          loading={loading}
          dataSource={dataSource}
          columns={columns}
          rowKey="id"
          pagination={{
            current: currentPage,
            pageSize: 20,
            total: total,
            showTotal: (total) => `共 ${total} 条`,
            onChange: (page) => fetchUsers(page),
          }}
        />
      </Card>

      <Modal
        title={`调整用户积分: ${currentUser?.name || currentUser?.username}`}
        open={adjustModalVisible}
        onOk={handleAdjustSubmit}
        onCancel={() => setAdjustModalVisible(false)}
        okText="确认调整"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="调整数值 (正数为加分，负数为扣分)"
            name="points_change"
            rules={[{ required: true, message: '请输入调整数值' }]}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            label="调整原因"
            name="description"
            rules={[{ required: true, message: '请输入调整原因' }]}
          >
            <Input placeholder="例如: 运营活动赠送" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default UserList;